<template name="error">
  <div>
    <h1>ERROR {{message}}</h1>
  </div>
</template>

<script>
export default {
  mounted () {
    switch (this.$route.params.type) {
      case 'not-support-rtc': {
        this.message = '화상연결을 지원하지 않는 브라우저입니다'
        break;
      }
      default: {
        this.message = '404 Not Found'
      }
    }
  },
  data () {
    return {
      message: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  h1 { color: white; }
</style>